import { isAdminRole, normalizeRole } from './permissions'

/** Admin/office may complete jobs despite incomplete checklist/photos (with a reason). */
export function canCompleteJobWithException(role?: string | null): boolean {
  const r = normalizeRole(role || '')
  return isAdminRole(r) || r === 'office'
}

export function completionExceptionUpdate(
  reason: string,
  userId: string | null | undefined
): {
  completion_exception_reason: string
  completion_exception_by: string | null
  completion_exception_at: string
} {
  return {
    completion_exception_reason: reason.trim(),
    completion_exception_by: userId || null,
    completion_exception_at: new Date().toISOString(),
  }
}
